module.exports = __webpack_public_path__ + "img/img_liantong.2aa4efc4.png";